export default __webpack_public_path__ + "static/media/mobisense_icon.2b8ca046.svg";